/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration, subentity } from '@gh/core-data';
import { HousePlanFilterDto } from '../';
import { FormulaMapper } from '../../common';
import { HousePlanFilterParameterDto } from '../models/house-plan-filter.dto';
import { HousePlanListItemDto } from '../models/house-plan-list-item.dto';
import { HousePlanStyle } from '../models/house-plan-style.enum';

export const HousePlanListItemMapper = entity<HousePlanListItemDto>({
  style: enumeration(HousePlanStyle),
});

export const HousePlanFilterMapper = entity<HousePlanFilterDto>({
  filterParameter: subentity<HousePlanFilterParameterDto>({
    propagateFormulaFilter: subentity<any>({
      oldFormula: FormulaMapper,
    }),
  }),
});
